import { UserState } from '@/types/Auth';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: UserState = {
  userDetail: null,
  permissionsData: null,
  currentPlan: { id: 1, status: { id: 0 }, endDate: null, billingCycle: 1 },
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserDetail(state, action: PayloadAction<any>) {
      state.userDetail = action.payload;
    },
    updateUserDetailAction(state, action: PayloadAction<any>) {
      state.userDetail = { ...state.userDetail, ...action.payload };
    },
    setUserCurrentPlan(state, action: PayloadAction<UserState['currentPlan']>) {
      state.currentPlan = action.payload;
    },

    setPermissionsData(state, action: PayloadAction<any>) {
      state.permissionsData = action.payload;
    },
  },
});

export default userSlice.reducer;

export const { setUserDetail, updateUserDetailAction, setPermissionsData, setUserCurrentPlan } = userSlice.actions;
